import { useWindowSize } from "@elit-hair/elit-tools";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { APP_ROUTES_FULL } from "@/utils/routes";

import { CalendarAppointments } from "./components/calendar-appointments";

export const Route = createFileRoute(APP_ROUTES_FULL.CALENDAR_DETAILS)({
    component: RouteComponent,
    staticData: {
        config: {
            title: "calendar_details",
        },
    },
});

function RouteComponent() {
    const params = Route.useParams();
    const { t } = useTranslation();
    const id = params.id;

    const { size } = useWindowSize();

    const isDesktop = size.md;

    if (!id) {
        return <div>{t("calendar_not_found")}</div>;
    }

    if (!isDesktop)
        return (
            <div className="flex flex-col gap-4 h-full min-h-0">
                <CalendarAppointments calendarId={id} />
            </div>
        );

    return (
        <div className="flex gap-4 flex-1 min-h-0">
            <CalendarAppointments calendarId={id} />
        </div>
    );
}
